/* eslint-disable kf/const-naming-convention */
// import { t } from "@lingui/macro";
// import { i18n } from "../utils/i18n";
export const MIN_CHUNK_SIZE = 262144;
export const MIN_FILE_LENGTH = 10485760; //10MB

export const RE_TRY_LIMIT = 5;

export const DROP_BOX_FILE_LIST_URL =
  "https://api.dropboxapi.com/2/files/list_folder";
export const DROP_BOX_FILE_LIST_CONTINUE_URL =
  "https://api.dropboxapi.com/2/files/list_folder/continue";
export const DROP_BOX_FILE_SEARCH = "https://api.dropboxapi.com/2/files/search";
export const MEDIA_MIME_TYPES = [
  "image/jpeg",
  "image/gif",
  "image/png",
  "video/mp4",
  "video/x-msvideo",
  "video/3gpp",
  "video/x-ms-wmv",
  "video/quicktime",
  "application/x-mpegURL",
  "video/x-flv"
];
export const BOX = "box";
export const GDRIVE = "gdrive";
export const DROPBOX = "dropbox";
export const ONEDRIVE = "onedrive";
export const MYDRIVE = "myDrive";
export const SHAREDWITHME = "sharedWithMe";
export const SHAREDDRIVE = "sharedDrive";
export const ROOT = "root";
export const DATAPERPAGE = 40;

export const MEDIA_FILE_EXTENSION = [
  "gif",
  "jpg",
  "jpeg",
  "tiff",
  "png",
  "mkv",
  "flv",
  "avi",
  "mov",
  "wmv",
  "mp4",
  "3gp"
];
export const GOOGLE_DOCS_EXTENSION = {
  "application/vnd.google-apps.document": "doc",
  "application/vnd.google-apps.file": "txt",
  "application/vnd.google-apps.presentation": "ppt",
  "application/vnd.google-apps.script": "gs",
  "application/vnd.google-apps.spreadsheet": "xls",
  "application/vnd.google-apps.drawing": "png",
  "application/pdf": "pdf"
};

export const IMAGE_FILE_EXTENSION = [
  "gif",
  "png",
  "jpg",
  "jpeg",
  "jpe",
  "tiff",
  "tif"
];
export const IMAGE_MIME_TYPE = [
  "image/jpeg",
  "image/gif",
  "image/png",
  "image/tiff"
];

/*
image {
  maxHeight: 4320,
  minHeight: 10,
  maxWidth:7680,
  minWidth:10
}
*/
export const defaultConfig = {
  minCount: 0,
  maxCount: 10,
  minSize: 0,
  maxSize: 104857600,
  fileExtensions: ["*"],
  imageProps: {
    crop: false,
    sizes: [
      [60, 60, "thumbnail.jpg"],
      [900, 400, "preview.jpg"]
    ]
  },
  attachmentWidgetProps: {
    sizes: [
      [1200, 800],
      [100, 100]
    ],
    crop: false
  },
  imageWidgetProps: {
    sizes: [
      [1200, 800],
      [300, 300]
    ],
    crop: true
  },
  imageWidgetExtensions: ["JPG", "JPEG", "BMP", "PNG", "TIF"]
};

/*""" Generate thumbnail """*/
export const THUMBNAIL_SUPPORTED_EXTENSIONS = ["jpg", "png", "jpe", "jpeg"];

export const MIME_TYPES_MAP = {
  png: "image/png",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  jpe: "image/jpeg",
  svg: "image/svg+xml"
};

/** Image Quality used while converting the blob to image **/
export const IMAGE_QUALITY = 0.95;

export const ImageExtension = {
  SVG: "svg"
};

export const commonDirectoryOptions = [
  { name: "My Drive", id: "myDrive" },
  { name: "Shared with me", id: "sharedWithMe" }
];

export const driveDirectoryOption = {
  gdrive: [
    ...commonDirectoryOptions,
    { name: "Shared Drive", id: "sharedDrive" }
  ],
  box: [commonDirectoryOptions[0]],
  dropbox: [...commonDirectoryOptions],
  onedrive: [...commonDirectoryOptions]
};

export const DRIVE_SUPPORTING_IMAGE = ["png", "jpg", "jpeg"];

export const uploadOptions = [
  {
    id: "localFiles",
    imageName: "LocalFiles",
    label: "LocalFiles"
  },
  {
    id: "gdrive",
    imageName: "GDrive",
    serviceName: "GDrive",
    label: "GoogleDrive"
  },
  {
    id: "dropbox",
    imageName: "DropBox",
    serviceName: "DropBox",
    label: "DropBox"
  },
  {
    id: "onedrive",
    imageName: "OneDrive",
    serviceName: "OneDrive",
    label: "OneDrive"
  },
  {
    id: "box",
    imageName: "BoxDrive",
    serviceName: "Box",
    label: "Box"
  }
];
